module.exports = __webpack_public_path__ + "static/media/raftofthemedusa2014.091887cc.jpg";